import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles((theme) => ({
  input: {
    cursor: "initial !important",
    height: "40px",
    width: "100% !important",
    borderRadius: "8px !important",
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px !important",
    lineHeight: "24px",
    color: "#667085 !important",
    backgroundColor: "#FFFFFF",
    paddingLeft: "10px",
    "& input": {
      border: "none",
      color: "#667085 !important",
    },
  },
  borderDisabled: {
    border: `1px solid #C4C4C4 !important`,
  },
  borderDefault: {
    "&:hover": {
      border: (props: { hoverBorderColor?: string }) =>
        `1px solid ${props?.hoverBorderColor} !important`,
    },
    "&:active": {
      border: (props: { hoverBorderColor?: string }) =>
        `2px solid ${props?.hoverBorderColor} !important`,
    },
    border: `1px solid #C4C4C4 !important`,
  },
  borderError: {
    border: `1px solid #D92D20 !important`,
  },
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
  formHelper: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#D92D20",
    alignItems: "center",
    display: "flex",
    margin: 0,
  },
  label: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (props: { disabled?: boolean; hoverBorderColor?: string }) =>
      props?.disabled ? "#667085" : colors.brandBlue500,
    marginBottom: "4px",
  },
  required: {
    color: (props: { disabled?: boolean }) => (props?.disabled ? "#667085" : "#F04438"),
  },
}));

export default styles;
